//   window.SLIDECART_OPENED = function() {
//   // Fires whenever Slide Cart has been opened
//     window.SLIDECART_UPDATE()
// }

window.addEventListener('DOMContentLoaded', function() {  
    $(document).on('change', '#slidecart-giftbox input', function(e) {
      $('#slidecart-giftbox').addClass('hide')
      
      $.post('/cart/update.js', {updates: {39336462975130: 1}}).then(function() {
        window.SLIDECART_UPDATE()
        $('#slidecart-giftbox input').prop('checked', false)
      })
    })
    
    $(document).on('change', '#slidecart-giftnote input', function(e) {
      if ($(this).prop('checked')) {
        $('#slidecart-note-form').addClass('show')
      } else {
        $('#slidecart-note-form').removeClass('show')
      }
    })
    
    $(document).on('click', '#slidecart-note-form button', function(e) {
      e.preventDefault()
      var note =  $('#slidecart-note-form textarea').val()
      var data = { items: [
        {
          quantity: 1,
          id: 40614791643290,
          properties: {
            'note': note
          }
        }
      ]
                 }
      
      $.post('/cart/add.js', data).then(function() {
        $('#slidecart-note-form').removeClass('show')
        $('#slidecart-giftnote input').prop('checked', false)
        
        window.SLIDECART_UPDATE()
      })
    })
  })